import { base64ToBlob } from "@/utils/tool";
import { clientPut, createClient } from "@/utils/client";
import Axios from "@/utils/Axios";
import config from "@/config";

export const getOSSURL = async (base64Url: string) => {
  try {
    const { client: _client } = await createClient();

    // console.log(templateJSON);

    // 获取base64 url
    // const { url: base64Url } = await handleGetImgByJson(templateJSON);
    // base64 转换成 BLOB
    const imgFile: any = base64ToBlob(base64Url, "image/svg+xml");
    // 上传 到oss
    const previewUrl = await clientPut({
      file: imgFile,
      client: _client,
      filePath: `wpsd/${process.env.REACT_ENV}/${new Date().getTime()}.svg`,
    });
    // 重新拼接 oss url
    let _url = "/" + previewUrl.url.split("/").slice(3).join("/");
    _url = `https://nolipixpreview.nolibox.com${_url}`;

    return _url;
  } catch (e) {
    return "";
  }
};
// 修改头像
export function updateAvatar(form: FormData) {
  return Axios.post(
    "/user/api/v1/user/avatar",
    form,
    {
      "Content-Type": "multipart/form-data",
    },
    config.adminUrl,
  );
}
interface IUser {
  avatar: string;
  deptId: number;
  email: string;
  nickname: string;
  phone: string;
  postId: number;
  remark: string;
  roleId: number;
  sex: string;
  status: string;
  userId: number;
  username: string;
  banner: string;
}
// 更新用户信息
export function updateUserInfo(userInfo: Partial<IUser>) {
  return Axios.put("/user/api/v1/sys-user", { ...userInfo }, {}, config.adminUrl);
}
// 获取验证码
export interface GetPhoneVCodeRequestData {
  mobileNumber: string;
}
export function getPhoneVCode(data: GetPhoneVCodeRequestData) {
  return Axios.post("/user/api/v1/sms/verification", data, {}, config.adminUrl);
}
interface IpwdSet {
  code: string;
  mobileNumber: string;
  password: string;
}
// 修改密码
export const pwdSet = async (data: IpwdSet) => {
  return Axios.post("/user/api/v1/user/phone/pwd/set", data, {}, config.adminUrl);
};
interface IPhoneAuthParams {
  mobileNumber: string;
  code: string;
}
// 绑定手机
export const bindPhone = async (data: IPhoneAuthParams) => {
  return Axios.post("/user/api/v1/user/bind/phone/set", data, {}, config.adminUrl);
};
// 解绑微信
export const unbindWechat = async () => {
  return Axios.post("/user/api/v1/user/unbind/wechat", "", {}, config.adminUrl);
};
// 获取微信扫码二维码
export function getWeChatQrCode() {
  return Axios.post("/user/api/v1/wechat/official-account/qrcode", "", {}, config.adminUrl);
}
// 微信扫码轮询状态
export interface GetWeChatQrCodeScanStatusRequestData {
  key: string;
}
export function getWeChatQrCodeScanStatus(data: GetWeChatQrCodeScanStatusRequestData) {
  return Axios.post(
    "/user/api/v1/wechat/official-account/qrcode/status",
    { block: 0, ...data },
    {},
    config.adminUrl,
  );
}
interface IBindWechat {
  key: string;
}
// 绑定微信
export const bindWechat = async (data: IBindWechat) => {
  return Axios.post("/user/api/v1/user/bind/wechat", data, {}, config.adminUrl);
};

export const getOSSConfigType = () => {
  return Axios.get("/oss/oss_token", {}, {}, config.baseURL);
};

export interface PostEmailVerificationType {
  email: string;
  subject: 1 | 2 | 3;
}
// 发送邮件验证码
export const postEmailVerification = async (data: PostEmailVerificationType) => {
  return Axios.post("/user/api/v1/email/verification", data, {}, config.adminUrl);
};
export interface PostBindEmailType {
  old_email: string;
  email: string;
  code: string;
  type: 1 | 2; //1绑定2解绑
}
// 绑定/取消绑定邮箱
export const postBindEmail = async (data: PostBindEmailType) => {
  return Axios.post("/user/api/v1/user/bind/email", data, {}, config.adminUrl);
};
